import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import './About.css';

const About = () => {
  const { t } = useLanguage();
  return (
    <div className="about-page">
      <Navbar />

      <section className="page-hero">
        <div className="container">
          <h1>{t('about.title', 'About Us')}</h1>
          <p>{t('about.subtitle', 'Your trusted cleaning service partner')}</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-section">
            <h2>{t('about.whoWeAre', 'Who We Are')}</h2>
            <p>
              {t('about.whoWeAreText1', "We are a professional cleaning service company dedicated to providing high-quality cleaning solutions for both residential and commercial clients. With years of experience in the industry, we have built a reputation for reliability, professionalism, and exceptional service.")}
            </p>
            <p>
              {t('about.whoWeAreText2', "Our team consists of trained and verified cleaners who are committed to delivering outstanding results. We understand that your home or business is important to you, and we treat it with the same care and respect we would our own.")}
            </p>
          </div>

          <div className="about-section">
            <h2>{t('about.ourMission', 'Our Mission')}</h2>
            <p>
              {t('about.ourMissionText', "Our mission is to provide exceptional cleaning services that exceed our clients' expectations. We strive to create a clean, healthy, and comfortable environment for our clients while maintaining the highest standards of professionalism and integrity.")}
            </p>
          </div>

          <div className="about-section">
            <h2>{t('about.whyChooseUs', 'Why Choose Us')}</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <h3>{t('about.verifiedCleaners', 'Verified Cleaners')}</h3>
                <p>{t('about.verifiedCleanersDesc', 'All our cleaners undergo background checks and verification processes')}</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔒</div>
                <h3>{t('about.secureTrusted', 'Secure & Trusted')}</h3>
                <p>{t('about.secureTrustedDesc', 'Your keys and personal information are handled with utmost security')}</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⭐</div>
                <h3>{t('about.qualityGuaranteed', 'Quality Guaranteed')}</h3>
                <p>{t('about.qualityGuaranteedDesc', 'We guarantee satisfaction with our cleaning services')}</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📞</div>
                <h3>{t('about.directContact', 'Direct Contact')}</h3>
                <p>{t('about.directContactDesc', 'Get direct contact with your cleaning team for better communication')}</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌱</div>
                <h3>{t('about.ecoFriendly', 'Eco-Friendly')}</h3>
                <p>{t('about.ecoFriendlyDesc', 'We use environmentally friendly cleaning products')}</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⏰</div>
                <h3>{t('about.flexibleScheduling', 'Flexible Scheduling')}</h3>
                <p>{t('about.flexibleSchedulingDesc', 'We work around your schedule to provide convenient service')}</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>{t('about.ourValues', 'Our Values')}</h2>
            <div className="values-list">
              <div className="value-item">
                <h3>{t('about.reliability', 'Reliability')}</h3>
                <p>{t('about.reliabilityDesc', 'We show up on time and deliver consistent, high-quality service')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.trust', 'Trust')}</h3>
                <p>{t('about.trustDesc', 'We build long-term relationships based on trust and transparency')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.excellence', 'Excellence')}</h3>
                <p>{t('about.excellenceDesc', 'We strive for excellence in every cleaning job we undertake')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.respect', 'Respect')}</h3>
                <p>{t('about.respectDesc', 'We respect your property, privacy, and specific requirements')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>{t('about.readyToExperience', 'Ready to Experience Our Service?')}</h2>
          <p>{t('about.contactUsToday', 'Contact us today to get started')}</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">{t('about.contactUs', 'Contact Us')}</Link>
        
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
